class stickyBar {
  constructor(config) {
    this.options = { ...config };
    this.init = this.init.bind(this);
    this.init();
  }
  togglePadding({barHeight}){
    const nextElement = document.querySelector(`${this.options.nextElementSibling}`);
    nextElement.style.paddingTop = `${barHeight}px`;
  }
  scroll({ navBar, sticky, barHeight }) {
    if(window.pageYOffset == 0){
    	navBar.classList.remove(`${this.options.stickySelector}`);
      	this.togglePadding({barHeight:0});
    }else{
    	 navBar.classList.add(`${this.options.stickySelector}`);
      	this.togglePadding({barHeight});
    }
  }
  initScroll({ navBar }) {
    const sticky = navBar.offsetTop;
    const barHeight = navBar.offsetHeight;
    window.onscroll = () => this.scroll({ navBar, sticky, barHeight });
  }
  init() {
    const navBar = document.querySelector(`${this.options.selector}`);
    this.initScroll({ navBar });
  }
}